<template>
  <div class="message-box">
    <div class="image bg" :style="`background-image: url('${cardInfo.imgSrc}')`"></div>
    <!-- <img class="image" :src="cardInfo.imgSrc" alt=""> -->
    <div class="content">
      <a class="title" :href="cardInfo.link" target="_blank"><h1>{{ cardInfo.title }}</h1></a>
      <p class="text" v-if="cardInfo.text">{{ cardInfo.text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['cardInfo']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.message-box {
  display: flex;
  // justify-content: space-between;
  width: calc(50% - 30px);
  height: 140px;
  margin-bottom: 50px;
  @include mobile {
    width: 100%;
    flex-direction: column;
    height: auto;
    margin-bottom: 34px;
    padding-bottom: 26px;
    border-bottom: 1px solid #efefef;
    &:last-child {
      border: none;
    }
  }
  .image {
    flex: none;
    width: 232px;
    height: 100%;
    margin-right: 24px;
    border-radius: 3px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    @include mobile {
      width: 100%;
      height: 170px;
      margin-right: 0;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    @include mobile {
      margin-top: 15px;
    }
    .title {
      display: block;
      & h1 {
        color: $font-color1;
        font-size: $fontSize18;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 12px;
        transition: color .2s;
        @include limit-line-numbers(2);
        &:hover {
          transition: color .2s;
          color: $primary1;
        }
        @include mobile {
          line-height: 27px;
        }
      }
    }
    .text {
      text-align: justify;
      color: $font-color2;
      font-size: $fontSize16;
      font-weight: 400;
      line-height: 24px;
      @include limit-line-numbers(3);
    }
  }
}
</style>
